
import { SalesforceLeadForm } from "@/components";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    SalesforceLeadForm,
  },
});
